import { render, staticRenderFns } from "./pcHeader.vue?vue&type=template&id=ed8b155a&scoped=true&"
import script from "./pcHeader.vue?vue&type=script&lang=js&"
export * from "./pcHeader.vue?vue&type=script&lang=js&"
import style0 from "./pcHeader.vue?vue&type=style&index=0&id=ed8b155a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8b155a",
  null
  
)

export default component.exports